/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_ErrorInputs */



/**
* | output |
* | --- |
* | "Couldn't compute standings." |
*
* @param {League_Standings_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_error = /** @type {((inputs?: League_Standings_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de calculer le classement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron calcular las clasificaciones.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível calcular a classificação.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile calcolare la classifica.")
	return /** @type {LocalizedString} */ ("Couldn't compute standings.")
});